import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  themeColor: {
    "--swiper-theme-color": "white",
  },
  banner: {
    maxWidth: "100%",
    height: "auto",
  },
}));
